var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast"},[_vm._v(_vm._s(_vm.message))])
}
var staticRenderFns = []

export { render, staticRenderFns }